//#region src/core/ui/quality-radio-group/data.ts
const QualityRadioGroupDataAttrs = {
	/** Current quality value. */
	value: "data-quality",
	/** Present when quality selection is disabled. */
	disabled: "data-disabled",
	/** Present when quality selection is unavailable. */
	hidden: "data-hidden",
	/** Indicates quality availability (`available` or `unavailable`). */
	availability: "data-availability"
};
//#endregion
export { QualityRadioGroupDataAttrs };

//# sourceMappingURL=data.js.map